import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Cruise Spotter Connect</h3>
            <p>B2B lead generation and call routing platform for travel agents.</p>
            <div className="contact-info">
              <p><strong>Email:</strong> <a href="mailto:hello@cruisespotterconnect.com">hello@cruisespotterconnect.com</a></p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/for-agents">For Agents</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/refund-policy">Refund & Cancelation Policy</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="mailto:agents@cruisespotterconnect.com">Agent Support</a></li>
              <li><a href="mailto:billing@cruisespotterconnect.com">Billing</a></li>
              <li><a href="mailto:support@cruisespotterconnect.com">Technical Support</a></li>
            </ul>
            <p className="hours">Monday-Friday, 9 AM - 6 PM EST</p>
          </div>
        </div>

        <div className="footer-disclaimer">
          <p>
            Cruise Spotter Connect is a marketing and lead generation platform connecting
            cruise-interested consumers with independent, licensed travel advisors. We do not
            book travel, act as a seller of travel, or guarantee pricing or availability. All
            travel bookings and payments are handled directly between consumers and independent
            travel advisors. Travel advisors are independent contractors, not employees of
            Cruise Spotter Connect.
          </p>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Cruise Spotter Connect, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
